// src/components/SplashScreen.js
import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import splashAnimation from './assets/airedify.json'; 
import splashAnimationMobile from './assets/airedify-mobile.json'; 
import styled from 'styled-components';

const SplashScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9); // Slight transparency for background
  z-index: 1000;
  overflow: hidden; // Ensure no scroll bars or overflow
`;

const FullScreenLottie = styled(Lottie)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  transform: scale(1.2); // Slightly scale to ensure it covers the edges
`;

function SplashScreen() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Adjust the breakpoint as needed

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Automatically hide splash screen after 5 seconds
    const timer = setTimeout(() => {
      console.log("Splash screen finished");
      // You can set a state to hide the splash screen here
    }, 5000); // 5 seconds

    return () => {
      clearTimeout(timer); // Cleanup timer on unmount
      window.removeEventListener('resize', handleResize); // Cleanup resize listener
    };
  }, []);

  return (
    <SplashScreenContainer>
      <FullScreenLottie
        animationData={isMobile ? splashAnimationMobile : splashAnimation}
        loop={false} // Assuming you want the animation to play once
      />
    </SplashScreenContainer>
  );
}

export default SplashScreen;
